import React from "react";
import styles from "./AboutXchangeOn.module.scss";
import Image from "next/image";
import Link from "next/link";

const AboutXchangeOn = () => {
  return (
    <section className={styles.aboutXchangeOn}>
      <div className={styles.container}>
        <div className={styles.image}>
          <Image
            src='/assets/Image/xchange.png'
            width={500}
            height={588}
            alt='image'
            className={styles.img}
          />
        </div>
        <div className={styles.content}>
          <h1 className={styles.title}>
            Buy with
            <br /> <span className={styles.titleSpan}>XchangeOn (ITO)</span>
          </h1>

          <p className={styles.paraghraph}>
            Buy your B-Love token from centralized per to per XchangeOn Platform
            and get the initial token offering (ITO)
          </p>

          <div className={styles.flexContent}>
            <div className='w-[25px] h-[25px]'>
              <Image
                alt='xchangeIcon'
                src='/assets/svg/xchangeIcon.png'
                width={25}
                height={25}
              />
            </div>
            <p className={styles.text}>
              Register on Xchangeon.io or download the XchangeOn App from google
              playstore
            </p>
          </div>
          <div className={styles.flexContent}>
            <div className='w-[25px] h-[25px]'>
              {' '}
              <Image
                alt='xchangeIcon'
                src='/assets/svg/xchangeIcon.png'
                width={25}
                height={25}
              />
            </div>
            <p className={styles.text}>Swap BLV token with BFICoin</p>
          </div>

          <div className={styles.flexContent}>
            <div className='w-[25px] h-[25px]'>
              <Image
                alt='xchangeIcon'
                src='/assets/svg/xchangeIcon.png'
                width={25}
                height={25}
              />
            </div>
            <p className={styles.text}>
              Despoit BFIC in your XchangeOn account
            </p>
          </div>

          <div className={styles.flexContent}>
            <div className='w-[25px] h-[25px]'>
              <Image
                alt='xchangeIcon'
                src='/assets/svg/xchangeIcon.png'
                width={25}
                height={25}
              />
            </div>
            <p className={styles.text}>
              Transfer BLV tokens to Beloved Network App and start staking.
            </p>
          </div>

          <div className={styles.qrcode}>
            <Link
              href='https://play.google.com/store/apps/details?id=com.xchangeonio&hl=en_IN&gl=US&pli=1'
              target='_blank'
            >
              <button className={styles.btn}>Download App</button>
            </Link>
            <Image
              alt='xchangeIcon'
              src='/assets/Image/qr.png'
              width={90}
              height={90}
            />
          </div>
        </div>
      </div>
    </section>
  )
};

export default AboutXchangeOn;
